import axios from "./axios";
import { getCompanyDisplayName } from "./companyDisplayName";

/** Fetches latest subadmin dashboard payload (company profile, stats). */
export const fetchCompanyDashboard = async (): Promise<Record<string, unknown> | null> => {
  const res = await axios({
    URL: "/omw/subadmin-dashboard",
    method: "GET",
  });
  const data = res?.data?.data;
  if (!data || typeof data !== "object") return null;
  return data as Record<string, unknown>;
};

export const resolveCompanyDisplayName = (
  companyData?: Record<string, unknown> | null
): string => getCompanyDisplayName(companyData) || "Your Company";
